module.exports = __webpack_public_path__ + "img/over-1.787259ea.png";